
<template>
    <label :class="labelClassName" :for="id" v-if="label">
        {{ label }}
        <span :class="$spa.css.form.helper" v-if="helper">{{ helper }}</span>
    </label>
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default() {
                    return null;
                }
            },
            helper: {
                type: String,
                default: null
            },
            className: {
                type: String,
                default() {
                    return this.$spa.css.form.label;
                }
            }
        },
        computed: {
            labelClassName() {
                if ( this.className !== null ) {
                    return this.className;
                }

                return this.$spa.css.form.label;
            }
        }
    }
</script>
